
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transportation-rules",
      function () {
        return require("private-next-pages/transportation-rules.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transportation-rules"])
      });
    }
  